import card1 from "../../../../assets/issueAndSecurity/1.png";
import card2 from "../../../../assets/issueAndSecurity/2.png";
import card3 from "../../../../assets/issueAndSecurity/3.png";
import card4 from "../../../../assets/issueAndSecurity/4.png";

const ImgArr = [card1, card2, card3, card4];

export default ImgArr;
